var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.barsAndLines = function (widget, chart, data, metadata) {
    var proxyToStackedBars = true;
    var debugWidget = widget.data('id') === '89b6f3f0-cebe-44e7-a013-0974a7c59295';

    if(proxyToStackedBars) {
        if(metadata){
            var kConf = metadata.KendoConfig || {};
            
            if(!kConf.categoryAxis) {
                kConf.categoryAxis = {};
            }
            if(!kConf.categoryAxis.labels) {
                kConf.categoryAxis.labels = {};
            }

            //Stacked bars defaults rotation to 45, as to not break existing widgets, default to 0
            if(kConf.categoryAxis.labels.rotation === undefined){
                kConf.categoryAxis.labels.rotation = 0;
            }

            metadata.KendoConfig = kConf;
        }
        
        return MDB.Charts.renderers.stackedBars(widget, chart, data, metadata);
    }
    
    
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }
    
    //LEGACY RENDERER
    setTimeout(function () {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);

        var useLegacyKeyTransform = metadata && metadata.KendoConfig && metadata.KendoConfig._UseLegacyKeyTransformation;

        var keyMappings = MDB.Charts.transformKeysToKendoFields(data, useLegacyKeyTransform);
        var aliasses = MDB.Charts.getColumnAliasses(widget);
        
        var container = $('<div class="barsAndLines">').css({ width: '90%', height: '90%', top: '5%', left: '5%' });
        var axisData = data[0];

        var keys = MDB.Charts.getDataKeys(axisData);
        var sharedValueAxisMax = metadata && metadata.KendoConfig && metadata.KendoConfig._SharedValueAxisMax;
        
        var kendoConfig = {
            dataSource: {
                data: data
            },
            categoryAxis: {
                field: keyMappings[0].field,
                labels: {
                    //rotation: "auto"
                },
                type: metadata.ColumnTypes[keyMappings[0].originalKey]
            },
            series: keys.slice(1).reduce(function (result, key) {
                var keyMapping = keyMappings.findByKey(key) || {key: key, originalKey: key};

                result.push({
                    name: aliasses[keyMapping.originalKey],
                    field: keyMapping.field
                });
                return result;
            }, [])
        };

        $.extend(true, kendoConfig, metadata.KendoConfig);
        
        var formatableValues = MDB.Charts.getAggregatedFormatableValues(data, keys);
        
        // Use each series' axis label format as its tooltip format if it is available and nothing else is defined.
        kendoConfig.series.forEach(function (series) {
            var seriesDefaults = kendoConfig.seriesDefaults[series.type || kendoConfig.seriesDefaults.type];
            var seriesAxis = series.axis;
            
            if (seriesDefaults && seriesAxis && kendoConfig.valueAxes) {
                var axisConfig = _.find(kendoConfig.valueAxes, function (axis) {
                    return axis.name === seriesAxis 
                });
                var axisLabelFormat = axisConfig && axisConfig.labels && axisConfig.labels.format;
                var seriesTypeHasTooltip = seriesDefaults.tooltip && seriesDefaults.tooltip.visible;
                var allSeriesHaveTooltips = kendoConfig.seriesDefaults.tooltip && kendoConfig.seriesDefaults.tooltip.visible;
                var seriesTypeHasNoTooltipFormat = !seriesDefaults.tooltip.format && !kendoConfig.seriesDefaults.tooltip.format;
                
                MDB.Charts.setLabelFormat(series, [axisConfig, seriesDefaults, kendoConfig.seriesDefaults], formatableValues);
                MDB.Charts.setLabelFormat(series, [seriesDefaults, kendoConfig.seriesDefaults], formatableValues, series.field, 'tooltip');

                MDB.Charts.setLabelFormat(axisConfig, [seriesDefaults, kendoConfig.axisDefaults], formatableValues, series.field);


                if (axisLabelFormat && (seriesTypeHasTooltip || allSeriesHaveTooltips) && seriesTypeHasNoTooltipFormat) {
                    if (!series.tooltip || !series.tooltip.template){
                        series.tooltip = { 
                            format: axisLabelFormat 
                        };
                    }
                }
            }
        });
        
        var setSharedMaxLabelValue = function (visibleSeries, valueAxis) {
            if (!sharedValueAxisMax){
                return;
            }

            var maxLabelValue = calculateSharedMaxLabelValue(data, visibleSeries);

            valueAxis.forEach(function (axis) {
                axis.max = maxLabelValue;
            });
        };

        setSharedMaxLabelValue(kendoConfig.series, kendoConfig.valueAxes);
        
        MDB.Charts.initializeLegendClickHandler(kendoConfig, function (visibleSeries) {
            setSharedMaxLabelValue(visibleSeries, container.data('kendoChart').options.valueAxis);
        });
        
        chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget)).append(container);
        container.kendoChart(kendoConfig);
    }, 0);
    
    function calculateSharedMaxLabelValue(data, visibleSeries) {
        var seriesFields = _.map(visibleSeries, 'field');
        var majorGridline = 10;
        
        //Take all visible values -> convert to floating point numbers -> take max
        var maxValue = _.max(_.flatMap(data, function(i){
            return _.map(_.values(_.pick(i, seriesFields)), parseFloat) 
        }));
        
        //Starting from 20, the major gridlines show up at an interval of 10
        if ((maxValue * 1.2) > 20){
            //https://stackoverflow.com/a/18953446/3697715
            maxValue = Math.ceil(maxValue / majorGridline) * majorGridline;
            
            return Math.max(maxValue * 1.2, maxValue + majorGridline);
        } 
        
        return maxValue * 1.2;
    }
};